// Utility function to create missing activity documents in Firestore
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const createMissingActivity = async (activityNumber, imageUrl) => {
  try {
    console.log('🔄 Creating missing activity document...');
    
    const activityData = {
      number: activityNumber,
      title: `Daily Activity ${activityNumber}`,
      description: `Creative activity for developing artistic thinking - Activity ${activityNumber}`,
      content: [
        `Welcome to Activity ${activityNumber}!`,
        `This is a creative activity designed to help you develop your artistic skills and imagination.`,
        `Follow the instructions in the activity image to create your artwork`
      ],
      imageUrl: imageUrl,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      type: 'daily_activity',
      difficulty: 'Beginner',
      duration: '20 minutes',
      materials: 'Paper, pencils, crayons, markers, or any art supplies you prefer',
      category: 'Creative Expression'
    };

    console.log('📝 Activity data:', activityData);
    
    const docRef = await addDoc(collection(db, 'activities'), activityData);
    
    console.log('✅ Activity document created successfully:', docRef.id);
    return docRef.id;
    
  } catch (error) {
    console.error('❌ Error creating activity document:', error);
    throw error;
  }
};

// Function to create the missing activity for your uploaded image
export const createYourMissingActivity = async () => {
  const imageUrl = 'https://firebasestorage.googleapis.com/v0/b/artmosphere-89b64.firebasestorage.app/o/activities%2FScreenshot%202025-09-05%20at%205.37.28%20PM.png?alt=media';
  
  try {
    const docId = await createMissingActivity(3, imageUrl);
    console.log('🎉 Your missing activity document has been created!');
    console.log('📄 Document ID:', docId);
    console.log('🔄 Now refresh the page and try clicking the Daily Art Activity button again!');
    return docId;
  } catch (error) {
    console.error('❌ Failed to create missing activity:', error);
    throw error;
  }
};
